// extracted by mini-css-extract-plugin
export default {"screen_size_message":"index__screen_size_message__f8SkO","screenSizeMessage":"index__screen_size_message__f8SkO"};